export const PRO_FEATURES = [
  "BYOK via OpenRouter — your key, your bill, your provider",
  "Lives inside Telegram",
  "Drafts every follow-up · pre-call briefs · deal radar",
  "HubSpot · Notion · Linear · Gmail · Calendar · Apollo · Luma",
  "Build any automation in plain English",
  "Dedicated Firecracker microVM · encrypted vault · per-tool toggles",
];

export const ENTERPRISE_FEATURES = [
  "Everything in Individual",
  "Multi-seat with shared context across the team",
  "Shared deal radar — see what teammates are working",
  "Custom SSO via WorkOS",
  "Self-hosting (roadmap)",
  "SCIM · signed DPA · on request",
  "Dedicated onboarding",
];
